import {
  ExpertSystemHierarchyNode,
  KpiCalculationError,
  InstallationStatus,
  MillType
} from '@hconnect/common/types'

export enum ExpertSystemUsageRateColumnKeys {
  // this keeps the order of the columns as is
  // ex: Location is first column, Responsible is second column, etc.
  LOCATION = 'location',
  MILL_TYPE = 'millType',
  EXPERT_SYSTEM_NAME = 'expertSystemName',
  JAN = 'jan',
  FEB = 'feb',
  MAR = 'mar',
  APR = 'apr',
  MAY = 'may',
  JUN = 'jun',
  JUL = 'jul',
  AUG = 'aug',
  SEP = 'sep',
  OCT = 'oct',
  NOV = 'nov',
  DEC = 'dec',
  AVERAGE = 'value',
  WEIGHTED_AVERAGE = 'weightedAverage'
}

export type HierarchyTableNode = Omit<ExpertSystemHierarchyNode, 'children'> &
  MonthColumns & {
    subItems?: HierarchyTableNode[]
    average?: number
    averageError?: KpiCalculationError
    averageIsDirty?: boolean
    weightedAverage?: number
    weightedAverageError?: KpiCalculationError
  }

export type MonthDataColumns = {
  [key: string]: MonthColumns
}

export type MonthColumns = {
  jan?: MonthData
  feb?: MonthData
  mar?: MonthData
  apr?: MonthData
  may?: MonthData
  jun?: MonthData
  jul?: MonthData
  aug?: MonthData
  sep?: MonthData
  oct?: MonthData
  nov?: MonthData
  dec?: MonthData
}

export type MonthData = {
  value?: number
  isEditedManually: boolean
  isDirty: boolean
  kpiCalculationError?: KpiCalculationError
  hasComments?: boolean
}

export type Item = {
  id?: string
  name: string
  millType?: MillType
  expertSystemName?: string
  kpiAssignmentId: string
  label?: string
  upmDepartmentId?: string
  provider?: string
  installationStatus?: InstallationStatus
  installationStatusText?: string
  installationYear?: string
}

export type AssignedUser = {
  userId: string
  id: string
  name: string
}
